export const APP_ROUTES = {
  AUTH: {
    ROOT: 'auth',
    LOGIN: 'login',
  },
  ADMIN: {
    ROOT: 'bo',
    DASHBOARD: 'dashboard',
    REPORTS: 'reports',
    FEATURES: {
      ROOT: 'features',
      LIST: 'list',
      ADD: 'add',
      EDIT_PARAM: 'edit',
      EDIT_ID: (featureId: string | number) => `edit/${featureId}`,
    },
    PLANS: {
      ROOT: 'plans',
      LIST: 'list',
      ADD: 'add',
      EDIT_PARAM: 'edit',
      EDIT_ID: (planId: string | number) => `edit/${planId}`,
    },
    ENTERPRICES: {
      ROOT: 'enterprises',
      LIST: 'list',
      DETAILS: 'details',
      DETAILS_ID: (id: string | number) => `details/${id}`,
      INCOMPLETE: 'incomplete-enterprises',
      ADD_USER: 'add-user',
      EDIT_USER: 'edit-user',
      ADD_ORGANIZATION: 'add-organization',
      EDIT_ORGANIZATION: 'edit-organization',
      ADD_PLAN: 'add-plan',
      EDIT_PLAN: 'edit-plan',
      ORDER_SUMMARY: 'order-summary',
      PAYMENT_CAPTURE: 'payment-capture',
      ONBOARDING_SUCCESS: 'onboarding-success',
      VERIFY_OTP: 'verify-otp',
    },
    TEMPLATES: {
      ROOT: 'templates',
      LIST: 'list',
      ADD: 'add',
      VIEW_PARAM: 'view',
      VIEW_ID: (id: string | number) => `view/${id}`,
      EDIT_PARAM: 'edit',
      EDIT_ID: (id: string | number) => `edit/${id}`,
    },
    LEAD_CAPTURE: {
      ROOT: 'lead-capture',
      LIST: 'list',
    },
  },
};
